import {
  serviceUnavailableViewModel,
  type ServiceUnavailableViewModel,
} from '@adapters/presenters/serviceUnavailable';
import { serviceUnavailableTag } from '@ui/elementTags';
import { applyNhsGlobal } from '@ui/styles/applyNhsGlobal';
import homePageStyles from '@ui/styles/nhs-subsets/nhs-home-page.scss?inline';
import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement(serviceUnavailableTag)
export class ServiceUnavailableComponent extends LitElement {
  @property({ attribute: false })
  public viewModel: ServiceUnavailableViewModel = serviceUnavailableViewModel;

  protected createRenderRoot(): HTMLElement | ShadowRoot {
    return applyNhsGlobal(this, homePageStyles);
  }

  public connectedCallback(): void {
    super.connectedCallback();
    void this.focusHeading();
  }

  public render() {
    const model = this.viewModel;

    return html`
      <section class="nhsuk-width-container" aria-labelledby="service-unavailable-title">
        <div class="nhsuk-grid-row">
          <div class="nhsuk-grid-column-two-thirds">
            <h1 class="nhsuk-heading-l" id="service-unavailable-title" tabindex="-1">${model.title}</h1>
            <p class="nhsuk-body">
              ${model.guidanceBeforeLink}<a href=${model.onlineLinkHref}>${model.onlineLinkText}</a>${model.guidanceBetweenLinks}<a href=${model.phoneLinkHref}>${model.phoneLinkText}</a>${model.guidanceAfterLinks}
            </p>
            ${model.answersRecoveryGuidance
              ? html`<p class="nhsuk-body">${model.answersRecoveryGuidance}</p>`
              : nothing}
            <p class="nhsuk-body">
              ${model.emergencyBeforeLink}<a href=${model.emergencyLinkHref}>${model.emergencyLinkText}</a>${model.emergencyAfterLink}
            </p>
          </div>
        </div>
      </section>
    `;
  }

  private async focusHeading(): Promise<void> {
    await this.updateComplete;
    this.renderRoot.querySelector<HTMLElement>('#service-unavailable-title')?.focus();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [serviceUnavailableTag]: ServiceUnavailableComponent;
  }
}
